module.exports = __webpack_public_path__ + "img/chord-label-F.2c530c9d.png";